import { Link } from "react-router-dom";
import logo from "../assets/logo.svg";
import "./footer.scss";
import ContainerLayout from "./ContainerLayout";

export const Footer = () => {
  return (
    <div className="nt-footer">
      <ContainerLayout>
        <div className="nt-footer__top">
          <div className="nt-footer__section nt-footer__section--left">
            <Link to="/" className="nt-footer__brand">
              <div className="nt-footer__logo">
                <img src={logo} alt="Logo" />
              </div>
            </Link>
          </div>

          <div className="nt-footer__section nt-footer__section--middle">
            <nav className="nt-footer__links">
              <ul className="nt-footer__links-list">
                <li className="nt-footer__links-item">
                  <Link to="/my-routes" className="nt-footer__link">
                    My Routes
                  </Link>
                </li>
                <li className="nt-footer__links-item">
                  <Link to="/points" className="nt-footer__link">
                    Credits
                  </Link>
                </li>
                <li className="nt-footer__links-item">
                  <Link to="/favourites" className="nt-footer__link">
                    Favourites
                  </Link>
                </li>
                <li className="nt-footer__links-item">
                  <Link to="/help" className="nt-footer__link">
                    Help
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          <div className="nt-footer__section nt-footer__section--right" />
        </div>

        <div className="nt-footer__bottom">
          <div className="nt-footer__copyright">
            <p>
              &copy; {new Date().getFullYear()} Nesiya Tova | All rights
              reserved.
            </p>
          </div>

          <div className="nt-footer__policies">
            <ul className="nt-footer__policies-list">
              <li className="nt-footer__policies-item">
                <Link to="#" className="nt-footer__policies-link">
                  Terms of Service
                </Link>
              </li>
              <li className="nt-footer__policies-item">
                <Link to="#" className="nt-footer__policies-link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </ContainerLayout>
    </div>
  );
};

export default Footer;
